<app-template-text [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [minlength]="minlength" [maxlength]="maxlength" [label]="label" />
